import { extractPhoneNumber } from '../validation/phoneNumber';

const DEFAULT_CONFIG = {
    delimiter: ',',
    fixCasing: true,
    defaultAcceptingTo: false
}

const COLUMN_SYNONYMS = {
    'PatientId': [
        'AccountNumber',
        'PID',
        'Id',
        'Pt ID',
        'pt#',
    ],
    'BrightreeId': [
        'ptkey',
    ],
    'SaleOrderNumber': [
        'SOKey',
        'SalesOrderId',
        'SONumber',
        'SalesNumber',
        'SO#',
    ],
    'BranchName': [
        'Branch',
    ],
    'FirstName': [
        'First',
    ],
    'LastName': [
        'Last',
    ],
    'PhoneNumber': [
        'Phone',
    ],
}

export const parseRawToContacts = (str, input_conf) => {
    const conf = Object.assign(DEFAULT_CONFIG, input_conf);

    // Ensure it can handle both types of new lines
    const rows = str.replace(/\r\n?/g, '\n').split('\n')
        .map(r => r.split(conf.delimiter).map(c => c.trim()));

    const synonyms = Object.entries(COLUMN_SYNONYMS);

    // Extract headers
    const headers = rows.shift().map(c => {
        const col = c.replace(/[ \-_]/g, '').toLowerCase();

        // Check if the header is in the COLUMN_SYNONYMS
        for (let i = 0; i < synonyms.length; i++) {
            if (
                col === synonyms[i][0].toLowerCase() ||
                synonyms[i][1].map(s => s.replace(/[ \-_]/g, '').toLowerCase()).includes(col)
            ) {
                return synonyms[i][0];
            }
        }

        return (conf.fixCasing ? capitalize(c) : c).replace(/[ \-_]/g, '');
    })

    return rows.map(r => {
        let obj = {
            key: Math.random().toString(36).slice(2),
        };

        for (let i = 0; i < headers.length; i++) {
            obj[headers[i]] =
                headers[i] === 'PhoneNumber'
                ? extractPhoneNumber(r[i])
                : r[i];
        }

        return obj;
    })
    .filter(r => headers.some(h => r[h]));
}

export const parseRawToZips = (str, input_conf) => {
    const conf = Object.assign(DEFAULT_CONFIG, input_conf);

    const rows = str.split('\n')
        .map(r => r.split(conf.delimiter).map(c => c.trim()));

    return rows.map(r => ({
        key: Math.random().toString(36).slice(2),
        zip: r[0],
        schedule: parseSchedule(r[1]),
        city: conf.fixCasing ? recapitalize(r[2]) : r[2],
        acceptingNewPatients: strToBool(r[3]) ?? conf.defaultAcceptingTo
    })).filter(r => r.zip || r.city || r.acceptingNewPatients);
}

const capitalize = s => s ? s.replace(/\b(?=\w)./g, m => m.toUpperCase()) : null;
const recapitalize = s => s ? s.toLowerCase().replace(/\b(?=\w)./g, m => m.toUpperCase()) : null;
const strToBool = (s) => s ? (s.toLowerCase() === 'yes' ? true : s.toLowerCase() === 'no' ? false : null) : null;

const parseSchedule = (str) => {
    if (!str) return str;
    str = str.trim();

    if (str === 'A') return { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true };

    const r = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false
    };

    const s = ['M', 'T', 'W', 'TH', 'F'];
    const m = {'M': 'monday', 'T': 'tuesday', 'W': 'wednesday', 'TH': 'thursday', 'F': 'friday'};

    const lines = str.split('    ');

    //Split multiple lines
    if (lines.length > 1) {
        for (let i = 0; i < lines.length; i++) {
            Object.entries(parseSchedule(lines[i]))
            .forEach(kv => {r[kv[0]] = (kv[1]) ? true : r[kv[0]]});
        }
    }

    const range = str.split('-');

    if (range.length === 2) {
        if (s.includes(range[0]) && s.includes(range[1])) {
            s.splice(s.indexOf(range[0]), s.indexOf(range[1]) + 1)
            .forEach(d => {
                r[m[d]] = true;
            })
        }

        return r;

    }

    const regex = /(\w+)/gm;
    let match;

    while ((match = regex.exec(str)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (match.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        
        match.forEach((matchValue) => {
            if (s.includes(matchValue.trim())) {
                r[m[matchValue.trim()]] = true;
            }
        });
    }

    return r;
}